export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  INTERNAL_SERVER_ERROR = 500
}

export class SuggestionListStatus {
  static readonly NEW = 'NEW';
  static readonly POSTPONE = 'POSTPONE';
  static readonly POSTPONE_EXPIRED = 'POSTPONE EXPIRED';
  static readonly POSTPONE_EXPIRED_UNDERSCORE = 'POSTPONE_EXPIRED';
  static readonly EXECUTING_TASKS = 'EXECUTING TASKS';
  static readonly EXECUTING_TASKS_UNDERSCORE = 'EXECUTING_TASKS';
  static readonly SUGGESTION_TASKS_EXPIRED = 'SUGGESTION TASKS EXPIRED';
  static readonly SUGGESTION_TASKS_EXPIRED_UNDERSCORE = 'SUGGESTION_TASKS_EXPIRED';
  static readonly REVIEWING = 'REVIEWING';
  static readonly CANCELLED = 'CANCELLED';
  static readonly IMPLEMENTED = 'IMPLEMENTED';
  static readonly APPROVE_CANCELLED = 'APPROVE CANCELLED';
}

export class TaskStatus {
  static readonly EXECUTING = 'EXECUTING';
  static readonly COMPLETED = 'COMPLETED';
  static readonly DONE = 'DONE';
}

export class SuggestionListStatusUtils {

  static isFinalStatus(status: string): boolean {
    return [
      SuggestionListStatus.EXECUTING_TASKS,
      SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE,
      SuggestionListStatus.CANCELLED,
      SuggestionListStatus.IMPLEMENTED
    ].indexOf(status) !== -1;
  }

  static isCreatableStatus(status: string): boolean {
    return [
      SuggestionListStatus.NEW,
      SuggestionListStatus.POSTPONE_EXPIRED,
      SuggestionListStatus.POSTPONE_EXPIRED_UNDERSCORE,
      SuggestionListStatus.SUGGESTION_TASKS_EXPIRED,
      SuggestionListStatus.SUGGESTION_TASKS_EXPIRED_UNDERSCORE
    ].indexOf(status) !== -1;
  }

  static isInProgressStatus(status: string): boolean {
    return [
      SuggestionListStatus.EXECUTING_TASKS,
      SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE,
      SuggestionListStatus.SUGGESTION_TASKS_EXPIRED,
      SuggestionListStatus.SUGGESTION_TASKS_EXPIRED_UNDERSCORE,
      SuggestionListStatus.REVIEWING
    ].indexOf(status) !== -1;
  }

  static normalizeStatus(status: string): SuggestionListStatus {
    switch (status) {
      case 'POSTPONE_EXPIRED':
        return SuggestionListStatus.POSTPONE_EXPIRED_UNDERSCORE;
      case 'EXECUTING_TASKS':
        return SuggestionListStatus.EXECUTING_TASKS_UNDERSCORE;
      case 'SUGGESTION_TASKS_EXPIRED':
        return SuggestionListStatus.SUGGESTION_TASKS_EXPIRED_UNDERSCORE;
      default:
        return status as SuggestionListStatus;
    }
  }
}


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/view-suggestion-list/view-suggestion-list.constants.ts